export const COUNTRIES = [
  // América del Sur
  { code: 'AR', name: 'Argentina', phoneCode: '+54' },
  { code: 'BO', name: 'Bolivia', phoneCode: '+591' },
  { code: 'BR', name: 'Brasil', phoneCode: '+55' },
  { code: 'CL', name: 'Chile', phoneCode: '+56' },
  { code: 'CO', name: 'Colombia', phoneCode: '+57' },
  { code: 'EC', name: 'Ecuador', phoneCode: '+593' },
  { code: 'GY', name: 'Guyana', phoneCode: '+592' },
  { code: 'PE', name: 'Perú', phoneCode: '+51' },
  { code: 'PY', name: 'Paraguay', phoneCode: '+595' },
  { code: 'SR', name: 'Surinam', phoneCode: '+597' },
  { code: 'UY', name: 'Uruguay', phoneCode: '+598' },
  { code: 'VE', name: 'Venezuela', phoneCode: '+58' },

  // América del Norte
  { code: 'US', name: 'Estados Unidos', phoneCode: '+1' },
  { code: 'CA', name: 'Canadá', phoneCode: '+1' },
  { code: 'MX', name: 'México', phoneCode: '+52' },

  // América Central
  { code: 'BZ', name: 'Belice', phoneCode: '+501' },
  { code: 'CR', name: 'Costa Rica', phoneCode: '+506' },
  { code: 'SV', name: 'El Salvador', phoneCode: '+503' },
  { code: 'GT', name: 'Guatemala', phoneCode: '+502' },
  { code: 'HN', name: 'Honduras', phoneCode: '+504' },
  { code: 'NI', name: 'Nicaragua', phoneCode: '+505' },
  { code: 'PA', name: 'Panamá', phoneCode: '+507' },

  // Caribe
  { code: 'DO', name: 'República Dominicana', phoneCode: '+1' },
  { code: 'PR', name: 'Puerto Rico', phoneCode: '+1' },
  { code: 'CU', name: 'Cuba', phoneCode: '+53' },

  // Europa
  { code: 'ES', name: 'España', phoneCode: '+34' },
  { code: 'FR', name: 'Francia', phoneCode: '+33' },
  { code: 'DE', name: 'Alemania', phoneCode: '+49' },
  { code: 'IT', name: 'Italia', phoneCode: '+39' },
  { code: 'PT', name: 'Portugal', phoneCode: '+351' },
  { code: 'GB', name: 'Reino Unido', phoneCode: '+44' },
  { code: 'NL', name: 'Países Bajos', phoneCode: '+31' },
  { code: 'BE', name: 'Bélgica', phoneCode: '+32' },
  { code: 'CH', name: 'Suiza', phoneCode: '+41' },
  { code: 'AT', name: 'Austria', phoneCode: '+43' },
  { code: 'SE', name: 'Suecia', phoneCode: '+46' },
  { code: 'NO', name: 'Noruega', phoneCode: '+47' },
  { code: 'DK', name: 'Dinamarca', phoneCode: '+45' },
  { code: 'FI', name: 'Finlandia', phoneCode: '+358' },
  { code: 'IE', name: 'Irlanda', phoneCode: '+353' },
  { code: 'GR', name: 'Grecia', phoneCode: '+30' },
  { code: 'PL', name: 'Polonia', phoneCode: '+48' },
  { code: 'CZ', name: 'República Checa', phoneCode: '+420' },
  { code: 'HU', name: 'Hungría', phoneCode: '+36' },
  { code: 'SK', name: 'Eslovaquia', phoneCode: '+421' },
  { code: 'RO', name: 'Rumania', phoneCode: '+40' },
  { code: 'BG', name: 'Bulgaria', phoneCode: '+359' },
  { code: 'HR', name: 'Croacia', phoneCode: '+385' },
  { code: 'SI', name: 'Eslovenia', phoneCode: '+386' },
  { code: 'EE', name: 'Estonia', phoneCode: '+372' },
  { code: 'LV', name: 'Letonia', phoneCode: '+371' },
  { code: 'LT', name: 'Lituania', phoneCode: '+370' },
  { code: 'CY', name: 'Chipre', phoneCode: '+357' },
  { code: 'MT', name: 'Malta', phoneCode: '+356' },
  { code: 'LU', name: 'Luxemburgo', phoneCode: '+352' },
  { code: 'IS', name: 'Islandia', phoneCode: '+354' },
  { code: 'LI', name: 'Liechtenstein', phoneCode: '+423' },
  { code: 'MC', name: 'Mónaco', phoneCode: '+377' },
  { code: 'AD', name: 'Andorra', phoneCode: '+376' },
  { code: 'SM', name: 'San Marino', phoneCode: '+378' },
  { code: 'VA', name: 'Ciudad del Vaticano', phoneCode: '+379' },
];

export const PHONE_CODES = COUNTRIES.reduce((acc, country) => {
  acc[country.phoneCode] = `${country.name} (${country.phoneCode})`;
  return acc;
}, {});
